export default {
  "AO": "244",
  "BW": "267",
  "CO": "57",
  "GH": "233",
  "IN": "91",
  "KE": "254",
  "MW": "265",
  "MZ": "258",
  "NG": "234",
  "NL": "31",
  "SZ": "268",
  "TG": "228",
  "TZ": "255",
  "UG": "256",
  "ZA": "27",
  "ZM": "260",
  "ZW": "263"
}
